import css from "./Dialog.module.css";
import React, { FC } from "react";

export const Dialog: FC = (props) => (
  <div>
    <div className={css.container} style={{}}>{props.children}</div>
  </div>
);
